var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.3","d":"M23.0295 5.28467H2.98779V22.4792H23.0295V5.28467Z","fill":"#0A9828","key":0}),React.createElement("path",{"d":"M20.592 9.6416H5.42529V11.5374H20.592V9.6416Z","fill":"#0A9828","key":1}),React.createElement("path",{"d":"M20.592 13.3794H5.42529V15.2752H20.592V13.3794Z","fill":"#0A9828","key":2}),React.createElement("path",{"d":"M14.7961 17.1709H5.42529V19.0667H14.7961V17.1709Z","fill":"#0A9828","key":3}),React.createElement("path",{"d":"M8.4043 3.3042H6.7793V7.09587H8.4043V3.3042Z","fill":"#0A9828","key":4}),React.createElement("path",{"d":"M19.2378 3.3042H17.6128V7.09587H19.2378V3.3042Z","fill":"#0A9828","key":5})]);
}

Calendar.defaultProps = {"id":"icon-calendar","viewBox":"0 0 27 26","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
